import type { ReactNode } from "react";
import { PencilSquareIcon } from "@heroicons/react/24/solid/index";
import { GLAWithIcon } from "../general/GLAWithIcon.tsx";
import { InfoTooltip } from "../general/InfoTooltip.tsx";

interface CategoryPillProps {
    icon: string | null | undefined;
    label: string;
    onWrongGLAClick?: () => void;
    lockedByMatchTooltip?: string;
    suffix?: ReactNode;
}

export default function GLAPill({
    icon,
    label,
    onWrongGLAClick,
    lockedByMatchTooltip,
    suffix,
}: CategoryPillProps) {
    const isInteractive = !!onWrongGLAClick;

    return (
        <div
            className={`group flex items-center gap-x-2 ${isInteractive ? "cursor-pointer" : ""}`}
            onClick={() => onWrongGLAClick?.()}
        >
            <GLAWithIcon icon={icon} label={label} iconSize="xs" interactive={isInteractive} suffix={suffix} />

            {lockedByMatchTooltip ? (
                <InfoTooltip text={lockedByMatchTooltip} className="text-gray-400" position="top" />
            ) : (
                <div className={"text-transparent group-hover:text-gray-400 cursor-pointer"}>
                    {onWrongGLAClick && <PencilSquareIcon className="size-4" />}
                </div>
            )}
        </div>
    );
}
